import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const FilterContainer = styled.View`
  max-height: 90%;
`;

export const HeaderContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(16)}px ${RFValue(24)}px;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
`;

export const HeaderTitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  flex: 1;
  text-align: center;
`;

export const HeaderBackButton = styled.TouchableOpacity`
  padding: ${RFValue(8)}px;
`;

export const BackIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.title};
  margin-left: -24px;
`;

export const FilterCard = styled.View`
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
  border: 1px solid ${({theme}) => theme.colors.border2};
  margin-bottom: ${RFValue(16)}px;
`;

export const Filter = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${RFValue(16)}px;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border2};
`;

export const FilterText = styled.Text<{active?: boolean}>`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme, active}) =>
    active ? theme.fonts.bold : theme.fonts.regular};
  color: ${({theme, active}) =>
    active ? theme.colors.primary : theme.colors.title};
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const FilterRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const FilterBadge = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(4)}px ${RFValue(8)}px;
  border-radius: ${RFValue(8)}px;
  margin-left: ${RFValue(8)}px;
`;

export const FilterBadgeText = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
`;

export const ButtonsContainer = styled.View`
  padding: ${RFValue(16)}px ${RFValue(24)}px;
  background-color: ${({theme}) => theme.colors.background};
`;
